export default __webpack_public_path__ + "f07da20753d6ffab154cae0cfbad2e63.png";